var map = {
	"./action_img.png": 108,
	"./background.png": 330,
	"./banner_shap.png": 331,
	"./cloud-computing.png": 332,
	"./cloud_01.png": 109,
	"./cloud_02.png": 110,
	"./cloud_03.png": 111,
	"./cloud_04.png": 112,
	"./cloud_05.png": 113,
	"./cloud_06.png": 114,
	"./crm_img1.jpg": 333,
	"./crm_img2.jpg": 334,
	"./crm_img3.jpg": 335,
	"./erp_dashboard.jpg": 115,
	"./erp_icon1.png": 336,
	"./erp_icon2.png": 337,
	"./erp_icon3.png": 338,
	"./erp_icon4.png": 339,
	"./erp_icon5.png": 340,
	"./erp_icon6.png": 341,
	"./growth.png": 342,
	"./img/01.png": 116,
	"./img/02.png": 117,
	"./img/03.png": 118,
	"./img/04.png": 119,
	"./img/05.png": 120,
	"./img/06.png": 121,
	"./img/07.png": 122,
	"./img/08.png": 123,
	"./img/09.png": 124,
	"./img/10.png": 125,
	"./img/11.png": 126,
	"./img/12.png": 127,
	"./img/13.png": 128,
	"./img/14.png": 129,
	"./img/15.png": 130,
	"./img/16.png": 131,
	"./img/17.png": 132,
	"./img/18.png": 133,
	"./img/19.png": 134,
	"./img/20.png": 135,
	"./quote.png": 343,
	"./rocket.png": 136,
	"./settings1.png": 344,
	"./shape.png": 345,
	"./testimonial_img.jpg": 346,
	"./testimonial_img2.jpg": 347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;